export default "__VITE_ASSET__BD3InN6q__"